import { motion } from "framer-motion";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../../contexts/ThemeContext";

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <motion.button
      onClick={toggleTheme}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.92 }}
      className={`
        relative p-2.5 rounded-xl transition-all duration-300
        bg-gray-100/80 dark:bg-gray-800/80 backdrop-blur-sm
        text-gray-700 dark:text-gray-200
        hover:bg-primary-50 dark:hover:bg-primary-900/30
        border border-gray-200/60 dark:border-gray-700/40
        hover:border-primary-200 dark:hover:border-primary-700
        hover:shadow-[0_0_16px_rgba(79,70,229,0.15)] dark:hover:shadow-[0_0_16px_rgba(129,140,248,0.12)]
      `}
      aria-label={`${isDark ? "Açık" : "Koyu"} temaya geç`}
    >
      <motion.div
        initial={false}
        animate={{
          rotate: isDark ? 180 : 0,
          scale: isDark ? 0 : 1,
          opacity: isDark ? 0 : 1,
        }}
        transition={{ duration: 0.35, ease: "easeInOut" }}
        className="absolute inset-0 flex items-center justify-center"
      >
        <Sun size={18} className="text-amber-500" />
      </motion.div>

      <motion.div
        initial={false}
        animate={{
          rotate: !isDark ? -180 : 0,
          scale: !isDark ? 0 : 1,
          opacity: !isDark ? 0 : 1,
        }}
        transition={{ duration: 0.35, ease: "easeInOut" }}
        className="flex items-center justify-center"
      >
        <Moon size={18} className="text-primary-400" />
      </motion.div>
    </motion.button>
  );
}
